import { BooleanKey, HierarchicalAnswer, IconPossibleAnswer, InputAnswer, InputWithUnitAnswer, PossibleAnswer, PossibleAnswerWithLabel } from "./interfaces";

export const isIconAnswer = (answer: PossibleAnswer): answer is IconPossibleAnswer => {
  return typeof answer === 'object' && answer !== null && 'iconKey' in answer;
};

export const isLabelAnswer = (answer: PossibleAnswer): answer is PossibleAnswerWithLabel => {
  return typeof answer === 'object' && answer !== null && 'key' in answer && 'label' in answer && !('iconKey' in answer);
};

export const isInputAnswer = (answer: PossibleAnswer): answer is InputAnswer => {
  return typeof answer === 'object' && answer !== null && 'type' in answer && answer.type === 'input';
};

export const isInputWithUnitAnswer = (answer: PossibleAnswer): answer is InputWithUnitAnswer => {
  return typeof answer === 'object' && answer !== null && 'type' in answer && answer.type === 'inputWithUnit';
};

export const isPrimitiveAnswer = (answer: PossibleAnswer): answer is boolean | number | string => {
  return typeof answer === 'boolean' || typeof answer === 'number' || typeof answer === 'string';
};

export const isBooleanAnswer = (answer: PossibleAnswer): answer is boolean => {
  return typeof answer === 'boolean';
};

export const isNumberAnswer = (answer: PossibleAnswer): answer is number => {
  return typeof answer === 'number';
};

export const isStringAnswer = (answer: PossibleAnswer): answer is string => {
  return typeof answer === 'string';
};


export const isBooleanKeyAnswer = (answer: PossibleAnswer): answer is BooleanKey => {
  return typeof answer === 'object' && answer !== null && 'key' in answer && 'label' in answer && 
         typeof (answer as any).key === 'boolean' && !('iconKey' in answer);
};

export const isHierarchicalAnswer = (answer: PossibleAnswer): answer is HierarchicalAnswer => 
  typeof answer === 'object' && 
  answer !== null && 
  'key' in answer && 
  'label' in answer && 
  'hasChildren' in answer &&
  !('iconKey' in answer);
